export var ClickEventType;
(function (ClickEventType) {
    ClickEventType[ClickEventType["none"] = 0] = "none";
    ClickEventType[ClickEventType["open_url"] = 1] = "open_url";
    ClickEventType[ClickEventType["run_command"] = 2] = "run_command";
    ClickEventType[ClickEventType["suggest_command"] = 3] = "suggest_command";
    ClickEventType[ClickEventType["change_page"] = 4] = "change_page";
    ClickEventType[ClickEventType["copy_to_clipboard"] = 5] = "copy_to_clipboard";
})(ClickEventType || (ClickEventType = {}));
